import { useEffect } from 'react';

/** Prevent iOS keyboard re-opening on home after leaving a screen with focused inputs (T2-6436). */
export default function useBlurFocusedInputOnUnmount(): void {
  useEffect(
    () => () => {
      const el = document.activeElement as HTMLElement | null;
      el?.blur?.();
    },
    [],
  );
}
